import React, { Component } from 'react';
import { VendorListItem } from './VendorListItem';

export class VendorList extends Component {
    displayName = VendorList.name

    constructor(props) {
        super(props);
        this._open = this._open.bind(this);
        this._handleChange = this._handleChange.bind(this);

        this.state = {
            opened: false
        };
    }

    _open = () => {
        this.setState({ opened: !this.state.opened });
    }

    _handleChange = (item) => {
        const { onChange } = this.props;
        onChange(item);
    }

    render() {
        let classes = "c-filter is-openable";

        if (this.state.opened)
            classes += " is-opened";

        let selectedVendors = this.props.selectedVendors;

        return (
            <div className={classes}>
                <a href="#" className="c-filter__toggle" onClick={(e) => { e.preventDefault(); this._open(); }}>Filter<span> properties by data set</span></a>
                <div className="c-filter__content">
                    <ul className="c-filter__list">
                        <li className="c-filter__item">
                            <span className="c-select">
                                <input type="checkbox" className="c-select__input is-selectable"
                                    id="filterFreeOnly"
                                    checked={this.props.freeOnly === true}
                                    onChange={this.props.onToggleFreeOnly} />
                                <label className="c-select__label" htmlFor="filterFreeOnly">
                                    <span className="c-select__text">Free properties only</span>
                                </label>
                            </span>
                        </li>
                        {this.props.vendors.map((vendor, i) => {
                            let _checked = selectedVendors.indexOf(vendor.map) > -1;

                            return (
                                <VendorListItem key={i} vendor={vendor} checked={_checked} onChange={this._handleChange} />
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}